import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment';

@Pipe({
  name: 'dateFormat',
  standalone: false,
})
export class DateFormatPipe implements PipeTransform {
  transform(value: string | Date | null | undefined, format: string = 'MMM DD, YYYY'): string {
    if (!value) {
      return '-';
    }
    return (moment as any).default(value).format(format);
  }
}
